<template>
<div id="notice-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="notice-modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="notice-modalLabel">{{ currentNotice.title }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-header">
                <h6 class="my-0">등록일 : {{ currentNotice.created }}</h6>
            </div>
            <div class="modal-body" v-html="safeHTML(currentNotice.content)">
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import common from "@/mixins/common.js";

export default {
    props: ["currentNotice"],
    mixins: [
        common
    ]
}
</script>

<style>
#notice-modal table,
#notice-modal img {
    width: 100% !important;
}
</style>
